module.exports = __webpack_public_path__ + "img/zxbkpt.1bc515ff.png";